<div class="bg-white p-4">
  <h3 class="text-center">Notifications</h3>
  <mat-divider></mat-divider>
  <mat-list>
    @if(notifications.length === 0) {
    <mat-list-item>No Notifications</mat-list-item>
    } @else { @for (item of notifications; track item; let i= $index) {

    <mat-list-item
      matRipple
      class="nav-item"
      (click)="openNotification(item, i)"
    >
      <img
      matListAvatar
        src="https://material.angular.io/assets/img/examples/shiba2.jpg"
        alt="Photo of a Shiba Inu"
      />
      <div matListItemTitle>{{ item?.message }}</div>
      <div matListItemLine>{{ item?.entityId }}</div>
    </mat-list-item>
    } }
  </mat-list>
</div>
